import React from "react";
import clsx from "clsx";

import {
  Modal,
  ModalHeader,
  ModalBody,
} from "@transfr-inc/dashboard-components";

import "./upload-errors.modal.scss";
import { getActivityUploadStatusDescription } from "@views/library/constants/activity-upload-status.model";

export const UploadErrorsModal = ({ open, onClose, error, status }) => {
  const statusDescription = getActivityUploadStatusDescription(status);
  return (
    <Modal
      open={open}
      onClose={onClose}
      modalClassName={clsx("upload-errors-modal")}
    >
      <ModalHeader
        icon={["fa-regular", "triangle-exclamation"]}
        title="Error"
        className={clsx("error-icon")}
      ></ModalHeader>
      <ModalBody>
        {statusDescription && (
          <div className="status-description">{statusDescription}</div>
        )}
        {error && <div className="error-description">{error}</div>}
        {!error && (
          <div className="error-description">No error to display.</div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default UploadErrorsModal;
